import CPP from "./icons/C++ (CPlusPlus).svg";
import Java from "./icons/Java.svg";
import Python from "./icons/Python.svg";
import JavaScript from "./icons/JavaScript.svg";
import PHP from "./icons/PHP.svg";
import HTML from "./icons/HTML5.svg";
import CSS from "./icons/Tailwind CSS.svg"; // You can rename if there's a separate CSS icon
import ReactIcon from "./icons/React.svg";
import NextJs from "./icons/Nest.js.svg"; // assuming this is Next.js logo
import R_Native from "./icons/React.svg"; // Replace this with SVG if available
import Tail from "./icons/Tailwind CSS.svg";
import Bootstrap from "./icons/Bootstrap.svg";
import Node from "./icons/Node.js.svg";
import Express from "./icons/Express.svg";
import Spring from "./icons/Spring.svg";
import Laravel from "./icons/Laravel.svg";
import Django from "./icons/Django.svg";
import MDB from "./icons/MongoDB.svg";
import SQL from "./icons/MySQL.svg";
import S_Server from "./icons/Microsoft SQL Server.svg"; // If SQL Server is different, update accordingly
import PortgreSQL from "./icons/PostgresSQL.svg"; // If SQL Server is different, update accordingly
import GraphQL from "./icons/GraphQL.svg";
import Git from "./icons/Git.svg";
import AWS from "./icons/AWS.svg";
import Azure from "./icons/Azure.svg";
import Supabase from "./icons/supabase_BIG.svg";
import GitLab from './icons/GitLab.svg';
import FastAPI from './icons/FastAPI.svg';
// Add others like Azure, GitLab if needed
import NEXTJS from "./icons/started-nextui-nest-js.avif"

// AI / GenAI stack
import LangChain from "./icons/Langchain.jpg";
import LangGraph from "./icons/Langraph.jpg";
import LangSmith from "./icons/Langsmith.webp";
import Groq from "./icons/GROQ.webp";
import MistralAI from "./icons/Mistral AI.webp";
import Chroma from "./icons/CHROMA.png";
import Pinecone from "./icons/Pinecone.jpg";

// Additional data stores
import Neo4j from "./icons/Neo4j.webp";
import Redis from "./icons/Redis.png";
import Snowflake from "./icons/Snowflake.png";
export const experiences = [
  {
    company: "Pure Billion Technologies",
    role: "Software Engineer",
    duration: "(Dec 24 - Present)",
    description: `Working on building a new product using React.js, Next.js,Node.js, Express.js,Nest.js TypeScript, Supabase, and PostgreSQL. Exploring Azure for cloud services and deployment. Using Prisma for ORM. Also built a native mobile app using Expo React Native. Working on WCAG web accessibility and made the app 99% accessible. Migrating data using Snowflake schemas. Worked on PWA hybrid mobile and web applications. Using Cursor, Claude Code CLI, Gemini, GitHub Copilot, and Claude to increase productivity and speed of development. Also contributing to Gen AI and Agentic AI for future projects and products.`,
  },
  {
    company: "Trando Technology",
    role: "Software Developer",
    duration: "(Dec 23- Dec 24)",
    description: `  Working as a full stack developer, focusing on React.js and Next.js for frontend development, and deploying \nweb applications on AWS Amplify with CI/CD to automate the deployment and testing process. Utilizing \nNode.js and Express.js with MySQL and MongoDB databases, I also added a load balancer to increase the \nperformance of backend services, implementing replicas and indexing to improve server efficiency. \nIntegrated push notifications and email communication modules using Firebase and Nodemailer. Created \nbackground jobs to run processes in the background. Integrated payment gateways using Razorpay and \nStripe with webhooks to ensure payment processing. Currently working on a variety of projects, including \nEd-Tech, Fintech, and travel booking service provider web applications. `,
  },
  {
    company: "Logixi Technology",
    role: " Software Developer",
    duration: "1 Year 6 Months (Jun 22 - Dec 23)",
    description: `Gained valuable experience in backend development using Node.js, Express.js, and Laravel PHP tech stacks. \nExplored cloud services such as AWS (S3, EC2, RDS, Lambda, Amplify) and GCP. Created CI/CD pipelines using \nAWS and GitHub Action Runner with Node.js and Laravel. Learned about web servers like Nginx and Apache. \nDeveloped full-stack microservices Ed-Tech products using React.js, Node.js, and Laravel with MySQL. \nImproved product performance by implementing indexing to reduce latency and adding a load balancer to \ndistribute traffic across services.  `,
  },

];


// Organize skills by category
export const skillsData = [
  {
    // Leads the section: it's what the hero positions on.
    // `banner: true` — this category's artwork is wide marketing banners with
    // dark backgrounds, not square transparent logos, so its tiles render the
    // image as a dark band instead of inside the circular proficiency ring.
    // Swap in square SVG logos and this flag can go.
    category: "AI & GenAI",
    banner: true,
    skills: [
      { name: "LangGraph", svg: LangGraph, proficiency: 90 },
      { name: "LangChain", svg: LangChain, proficiency: 88 },
      { name: "LangSmith", svg: LangSmith, proficiency: 80 },
      { name: "Pinecone", svg: Pinecone, proficiency: 85 },
      { name: "Chroma", svg: Chroma, proficiency: 85 },
      { name: "Groq", svg: Groq, proficiency: 82 },
      { name: "Mistral AI", svg: MistralAI, proficiency: 82 },
    ]
  },
  {
    category: "Programming Languages",
    skills: [
      { name: "C++", svg: CPP, proficiency: 90 },
      { name: "Java", svg: Java, proficiency: 85 },
      { name: "Python", svg: Python, proficiency: 80 },
      { name: "JavaScript", svg: JavaScript, proficiency: 95 },
      { name: "PHP", svg: PHP, proficiency: 75 },
    ]
  },
  {
    category: "Frontend Development",
    skills: [
      { name: "HTML", svg: HTML, proficiency: 95 },
      { name: "CSS", svg: CSS, proficiency: 90 },
      { name: "React.js", svg: ReactIcon, proficiency: 90 },
      { name: "Next.js", svg: NEXTJS, proficiency: 85 },
      { name: "React Native", svg: R_Native, proficiency: 80 },
      { name: "Tailwind CSS", svg: Tail, proficiency: 85 },
      { name: "Bootstrap", svg: Bootstrap, proficiency: 90 },
    ]
  },
  {
    category: "Backend Development",
    skills: [
      { name: "Node.js", svg: Node, proficiency: 90 },
      { name: "Nest.js", svg: NextJs, proficiency: 85 },
      { name: "Express.js", svg: Express, proficiency: 85 },
      { name: "Spring Boot", svg: Spring, proficiency: 80 },
      { name: "Laravel", svg: Laravel, proficiency: 75 },
      { name: "Django", svg: Django, proficiency: 70 },
      { name: "Fast API", svg: FastAPI, proficiency: 80 }

    ]
  },
  {
    category: "Database & API",
    skills: [
      { name: "MongoDB", svg: MDB, proficiency: 85 },
      { name: "MySQL", svg: SQL, proficiency: 90 },
      { name: "SQL Server", svg: S_Server, proficiency: 80 },
      { name: "PostgreSQL", svg: PortgreSQL, proficiency: 85 },
      { name: "GraphQL", svg: GraphQL, proficiency: 75 },
      { name: "Supabase", svg: Supabase, proficiency: 75 },
      { name: "Redis", svg: Redis, proficiency: 80 },
      { name: "Snowflake", svg: Snowflake, proficiency: 75 },
      { name: "Neo4j", svg: Neo4j, proficiency: 70 },
    ]
  },
  {
    category: "Tools & Technologies",
    skills: [
      { name: "Git", svg: Git, proficiency: 90 },
      { name: "GitLab", svg: GitLab, proficiency: 90 },
      { name: "AWS", svg: AWS, proficiency: 80 },
      { name: "Azure", svg: Azure, proficiency: 80 },
      // { name: "JIRA", svg: JIRA, proficiency: 85 },
      // { name: "Scrum Agile", svg: Scrum, proficiency: 90 },
      // { name: "Data Structures", svg: DSA, proficiency: 85 },
    ]
  }
];
